import { Page, PageCollection } from '@typings/common';

export const insertPage = <T>(current: PageCollection<T>, page: Page<T>, index: number): PageCollection<T> => {
  const pages = [...current];
  pages[index] = page;
  return pages;
};
